<div class="action-dropdown-wrapper">
  <button
    class="dropdown-trigger"
    [class.disabled]="disabled"
    [attr.aria-expanded]="isOpen"
    [attr.aria-haspopup]="true"
    [disabled]="disabled"
    (click)="toggle()"
  >
    <span class="dropdown-label">{{ label }}</span>
    <mat-icon class="dropdown-caret">{{
      isOpen ? 'expand_less' : 'expand_more'
    }}</mat-icon>
  </button>

  <div class="dropdown-panel" *ngIf="isOpen">
    <button
      *ngFor="let option of options"
      class="dropdown-option"
      type="button"
      [class.option-disabled]="option.disabled"
      [disabled]="option.disabled"
      (click)="select(option)"
    >
      <mat-icon class="option-icon">{{ option.icon }}</mat-icon>
      <span class="option-label">{{ option.label }}</span>
    </button>
  </div>
</div>
